export default {
  IS_EMPTY: 'isEmpty',
  IS_NOT_EMPTY: 'isNotEmpty',
  IS_EMAIL: 'isEmail',
  IS_PHONE: 'isPhone',
  IS_PASSWORD: 'isPassword',
}
